import type { LanguageType } from '../../types/common';
import BubbleCommon from './BubbleCommon';
export * from './copywritingKey/metrics';
export * from './copywritingKey/summary';
export * from './copywritingKey/gameStore';
export * from './copywritingKey/topic';
export * from './copywritingKey/keyword';
export * from './copywritingKey/feeds';
export * from './copywritingKey/community';
export * from './copywritingKey/overview';
export * from './copywritingKey/gameList';
export * from './copywritingKey/filters';
export * from './copywritingKey/news';
export * from './copywritingKey/accounts';
export * from './copywritingKey/common';
export * from './copywritingKey/gpt';
export * from './copywritingKey/competitor';
export * from './copywritingKey/aigc';
export * from './copywritingKey/download';
export * from './copywritingKey/stats';
export * from './copywritingKey/steamPerformance';
export * from './copywritingKey/influencer';
export * from './copywritingKey/hero';
export * from './copywritingKey/compareKeyMetrics';
export * from './copywritingKey/keyOpinions';
export * from './copywritingKey/keyMetrics';
export * from './copywritingKey/compare';
export * from './copywritingKey/NIKKE';
export * from './copywritingKey/brandOverview';
export * from './copywritingKey/keywordDrillUrl';
export * from './copywritingKey/ChannelShareRanking';
export * from './copywritingKey/realtimeOpinions';
export * from './copywritingKey/aiTaskCenter';
export * from './copywritingKey/realtimeStreaming';
export * from './copywritingKey/hashtag';
export * from './copywritingKey/adCreative';

export type TipsMapType = {
  [key in LanguageType]?: string | JSX.Element;
} & { space?: number; sort?: Array<LanguageType> };

export type TipsMapFunType = (...anyParams: Array<any>) => TipsMapType;

export default BubbleCommon;
